import React, { useEffect } from "react";
import NavBar from "../Navigation/NavBar";
import Info from "./Info";
import { Helmet } from "react-helmet-async"; // Corrected import for meta tags
import GetInTouch from "../GetInTouch/GetInTouch";
import Footer from "../Footer/Footer";

function ContactUs() {
  useEffect(() => {
    window.scrollTo({ top: 0, left: 0, behavior: "smooth" });
  }, []);
  return (
    <>
      <Helmet>
        <meta name="keywords" content="HR solutions, placement services, recruitment, Quarec Resources" />
        <meta name="author" content="Quarec Resources" />
      </Helmet>
      <NavBar />
      <Info />
      <GetInTouch />
      <Footer />
    </>
  );
}

export default ContactUs;
